import { createElement } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import './index.scss';
import Sensor from '@max/mbc-sensor';
import { LX_CONFIG } from '../../type/const';
import Price from '@max/leez-price';
import { useMonitorEngineContext, useMonitorJumper } from '@nibfe/mcp-monitor-sdk';
import { getPlatformType, isDianpingAppOrWebview, isMeituanAppOrWebview, isMiniProgramOrWebview } from '@nibfe/mkt-env-api';
import { PlatformType } from '@nibfe/mkt-env-api/src/libs/enum';
import { appendImageWidth, convertToHttps } from '../../utils/image-utils';
export const VerticalDoubleItem = (props) => {
    const { vo, feConfig, onCardClick, onCardShow } = props;
    const { id, imageUrl, jumpNativeUrl, jumpH5Url, jumpWXUrl, counterPrice, promotionPrice, mtPrice, merchantName, title } = vo ?? {};
    const ctx = useMonitorEngineContext();
    const { monitorNavigateToSmart } = useMonitorJumper();
    const handleJump = () => {
        try {
            ctx._LXReport?.mcReportWithTag?.(LX_CONFIG.CARD_MC_BID, {
                valLab: {
                    custom: {
                        item_id: id,
                        tex_id: ctx?._runtimeInfo?.queryParams?.pageId ?? '-999',
                        click_biz_line: feConfig.click_biz_line ?? '-999',
                        hotel_channel: ctx?._runtimeInfo?.queryParams?.hotelchannel ?? '-999'
                    }
                }
            });
        }
        catch (error) { }
        try {
            if (isDianpingAppOrWebview() || isMeituanAppOrWebview()) {
                monitorNavigateToSmart(jumpNativeUrl);
                return;
            }
            if (isMiniProgramOrWebview()) {
                if (getPlatformType() === PlatformType.mtHotelMinaWebview) {
                    const hotelMinaJumpUrl = `/pages/navigator/index?appId=wxde8ac0a21135c07d&path=${encodeURIComponent(jumpWXUrl)}`;
                    monitorNavigateToSmart(hotelMinaJumpUrl);
                    return;
                }
                monitorNavigateToSmart(jumpWXUrl);
                return;
            }
            monitorNavigateToSmart(jumpH5Url);
        }
        catch (error) { }
    };
    return <Sensor key={id} className="vertical-double-card" once onAppear={() => {
        ctx._LXReport?.mvReport?.(LX_CONFIG.CARD_MV_BID, {
            valLab: {
                custom: {
                    item_id: id,
                    tex_id: ctx?._runtimeInfo?.queryParams?.pageId ?? '-999',
                    click_biz_line: feConfig.click_biz_line ?? '-999',
                    hotel_channel: ctx?._runtimeInfo?.queryParams?.hotelchannel ?? '-999'
                }
            }
        });
    }}>
      <View className="vertical-double-card" onClick={handleJump}>
        <View className="vertical-double-card__header-img-wrapper">
          <Image className="vertical-double-card__header-img" resizeMode="cover" source={{
        uri: appendImageWidth(convertToHttps(imageUrl), 375)
    }}/>
        </View>
        <View className="vertical-double-card__goods-info-wrapper">
          <Text className="vertical-double-card__goods-name" numberOfLines={1}>
            {title}
          </Text>
          <Text className="vertical-double-card__merchant-name" numberOfLines={1}>
            {merchantName}
          </Text>
          <View className="vertical-double-card__price-info-wrapper">
            <Price type="l3" color="#FF4B10" content={promotionPrice ?? mtPrice}/>
            <Price type="l6" crossed content={counterPrice}/>
          </View>
        </View>
      </View>
    </Sensor>;
};
